import $ from 'jquery';
import { useEffect, useMemo, useRef } from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import { useSelector } from 'react-redux';

const f = (d) => {
	if (!d) return;

	return (
		'<div className="col-md-12 row ellipsis-text">' + '<span><strong>Informasjon:&nbsp;</strong></span>' + '<span>' + d.note ||
		'-' + '</span>' + '</div>'
	);
};

export default function JFilteredDataTable({ data }) {
	const tableRef = useRef();
	const pStatus = useSelector((state) => state.content.projectStatusD);

	const projectsT = useMemo(() => data.map((d) => d.product_detail), [data]) || null;

	useEffect(() => {
		const table = $(tableRef.current).DataTable({
			data: projectsT,
			columns: [
				{ title: 'Kode', data: 'productprefix' },
				{ title: 'Nummer', data: 'productcodenumber' },
				{ title: 'Name', data: 'productname' },
			],
			destroy: true,
			responsive: {
				details: {
					type: 'column',
					target: 'tr',
				},
			},
			columnDefs: [
				{
					width: '10%',
					targets: 0,
					searchable: true,
					orderable: true,
					responsivePriority: 1,
					className: 'dt-control dt-head-center relative',
				},
				{ targets: 1, responsivePriority: 2, width: '10%' },
				{ targets: 2, responsivePriority: 3 },
				{ targets: [1], className: 'document-detail dt-head-center dt-body-center' },
				{
					targets: [1, 2],
					searchable: true,
					orderable: true,
					className: 'sorting document-detail',
				},
			],
			order: [[1, 'desc']],
			language: {
				emptyTable: 'Ingen resultater',
				info: 'Viser _START_ to _END_ of _TOTAL_ rader',
				infoEmpty: 'Viser 0 to 0 of 0 rader',
				thousands: '',
				infoFiltered: '(filtered from _MAX_ total rader)',
				lengthMenu: 'Viser _MENU_ rader',
				zeroRecords: 'Ingen resultater',
				paginate: {
					first: 'First',
					last: 'Last',
					next: 'Neste',
					previous: 'Forrige',
				},
			},
		});
		table.on('click', 'td.dt-control', function (e) {
			let tr = e.target.closest('tr');
			let row = table.row(tr);

			if (!row.child.isShown()) {
				row.child.hide();
			} else {
				row.child(f(row.data())).show();
			}
		});
		table.on('click', 'td.document-detail', function (e) {
			let tr = e.target.closest('tr');
			let row = table.row(tr)?.data();
			if (row) {
				const { productcodenumber: code, productversion: ver, productid: id } = row;
				window.open(window.location.origin + '/project/' + code + (ver && ver != '-' ? '_' + ver : '') + `/${id}`, '_blank');
			}
		});

		return function () {
			table.destroy();
		};
	}, [projectsT, pStatus]);

	return (
		data && (
			<div id='dt-wrapper' className='relative w-full'>
				<table className='w-full tb-default display nowrap' ref={tableRef}>
					<thead className='thead-light'></thead>
					<tbody></tbody>
				</table>
			</div>
		)
	);
}
